module.exports = __webpack_public_path__ + "static/media/regist.be86e6d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/regist.png
// module id = 666
// module chunks = 0